export const newUserInitialValues = (values) => ({
  firstName: values?.firstName || "",
  lastName: values?.lastName || "",
  createdDate: values?.createdDate || "",
  userRole: values?.userRole || [],
  email: values?.email || "",
  password: values?.password || "",
  confirmPassword: values?.confirmPassword || "",
});
